export default __webpack_public_path__ + "static/media/offers-percent.d0daf9d2.svg";